import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import axios from 'axios';
import { COMMON_API } from '../../CommonAPI';

const GetInTouchList = () => {
    const [contacts, setContacts] = useState([]);

    useEffect(() => {
        const fetchContacts = async () => {
            try {
                const token = sessionStorage.getItem("authToken");
                const response = await axios.get(`${COMMON_API}/api/connectus/all-get-in-touch`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setContacts(response.data.contacts);  // make sure your backend sends { contacts: [...] }
            } catch (error) {
                console.error(error);
                toast.error("Failed to fetch data!");
            }
        };
        fetchContacts();
    }, []);

    return (
        <div className="ml-64 p-8 bg-gray-100 min-h-screen">
            <h2 className="text-3xl font-semibold text-gray-800 mb-6">Get In Touch Submissions</h2>
            <div className="overflow-x-auto bg-white rounded shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">S.No</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">First Name</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Last Name</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Phone / Skype</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Project Description</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {contacts.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="text-center py-6">No submissions found.</td>
                            </tr>
                        ) : (
                            contacts.map((item, index) => (
                                <tr key={item.id}>
                                    <td className="px-6 py-4">{index + 1}</td>
                                    <td className="px-6 py-4">{item.fname}</td>
                                    <td className="px-6 py-4">{item.lname}</td>
                                    <td className="px-6 py-4">{item.email}</td>
                                    <td className="px-6 py-4">{item['phone/skype']}</td>
                                    <td className="px-6 py-4">{item.project_description}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default GetInTouchList;
